import React from 'react';
import { MobXProviderContext } from 'mobx-react';
// type-only: app.ts constructs a RootStore singleton (Pusher, localStorage,
// window globals) at module scope — a value import here would drag those side
// effects into any bundle that imports useStores (e.g. the MF mount shells).
// Mirrors the same fix in src/state/ui.ts.
import type { RootStore } from 'src/state/app';

export function useStores(): RootStore {
  return React.useContext(MobXProviderContext) as RootStore;
}
